import { type UseQueryResult, useQuery } from 'react-query';
import { useServices } from 'containers/services';
import type { MeterEventsFilter, MeterEventsResult } from 'lib/services/meterEventsApi';
import { QUERY_KEYS } from 'utils/queryKeys';

export const useMeterEvents = (filter: MeterEventsFilter): UseQueryResult<MeterEventsResult> => {
  const { meterEventsApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.meterEvents.find(filter),
    queryFn: ({ signal }) => meterEventsApiClient.find(filter, signal),
  });
};
